export class QualityType {
    id: string;
    name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

export class DocumentType {
    id: string;
    name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

export class Competention {
    id: string;
    description: string;
    qualityTypeIds: string[];
    examOrder: number;
    employerDescription: string;

    constructor(
        id: string,
        description: string,
        qualityTypeIds: string[],
        examOrder: number,
        employerDescription: string) {
        this.id = id;
        this.description = description;
        this.qualityTypeIds = qualityTypeIds;
        this.examOrder = examOrder;
        this.employerDescription = employerDescription;
    }
}

export class CostCentre {
    id: string;
    name: string;
    companyId: string;

    constructor(id: string, name: string, companyId: string) {
        this.id = id;
        this.name = name;
        this.companyId = companyId;
    }
}

export enum UserType {
    Employee = 0,
    Employer = 1
};

export enum EmployeeType {
    Employee = 0,
    Freelancer = 1,
    FixedEmployee = 2
};

export enum RequestRegistrationStatus {
    Pending = 0,
    Denied = 1,
    Accepted = 2,
    NoShow = 3
}

export enum ClockProcessStatus {
    PendingApproval = 0,
    ReadyForProcessing = 1,
    Processed = 2
}
